import React from "react";
import * as d3 from "d3";
import { apDateTimeLocale } from "../utils";

const timeFmt = apDateTimeLocale.format("%b");

const TimelineMinimap = ({
  timeline,
  current = null,
  handleClick = () => {},
}) => {
  // javascript months are 0-indexed, but days are still 1-indexed
  // range from 0 to 80 vh
  const year = [new Date(2020, 0, 1), new Date(2021, 0, 1)];
  const scale = d3.scaleTime().domain(year).range([0, 90]);
  const display =
    current === 0 || current === timeline.length + 1 ? "none" : "initial";
  current -= 1;
  current = d3.max([current, 0]);
  current = d3.min([current, timeline.length - 1]);

  return (
    <div className="timeline-minimap" style={{ display }}>
      {scale.ticks().map((date) => {
        return (
          <div className="tl__tick" style={{ top: `${scale(date)}vh` }}>
            {timeFmt(date)}
          </div>
        );
      })}
      {timeline.map(({ date }, idx) => (
        <div
          className="tl__entry"
          style={{
            top: scale(date) + "vh",
          }}
          onClick={() => handleClick(idx)}
          key={date}
        >
          <div className={`circle ${current === idx ? "active" : ""}`}></div>
        </div>
      ))}
      <div
        className="tl__progress"
        style={{
          height: scale(timeline[current].date) + "vh",
        }}
      ></div>
    </div>
  );
};

export default TimelineMinimap;
